/** Button + drawer entry for Models AI Assistant (stays mounted after first open). */
import { lazy, Suspense, useState } from "react";
import { mfgPrimaryBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";

const ManufacturingModelsAiAssistantDrawer = lazy(() =>
  import("./ManufacturingModelsAiAssistantDrawer").then((m) => ({
    default: m.ManufacturingModelsAiAssistantDrawer,
  })),
);

export function ManufacturingModelsAiAssistantLauncher({
  enabled,
  loading,
  onOpenRecipe,
  onCatalogMutated,
}: {
  enabled: boolean;
  loading: boolean;
  onOpenRecipe?: (recipeId: string) => void;
  onCatalogMutated?: () => void;
}) {
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  function openDrawer() {
    setMounted(true);
    setOpen(true);
  }

  return (
    <>
      <button
        type="button"
        className={mfgPrimaryBtnClass}
        onClick={openDrawer}
        disabled={!enabled || loading}
        title="Open Models AI Assistant"
        data-testid="mfg-models-ai-assistant"
      >
        AI Assistant
      </button>
      {mounted ? (
        <Suspense fallback={null}>
          <ManufacturingModelsAiAssistantDrawer
            open={open}
            onClose={() => setOpen(false)}
            onOpenRecipe={onOpenRecipe}
            onCatalogMutated={onCatalogMutated}
          />
        </Suspense>
      ) : null}
    </>
  );
}
